import { Grid } from "antd";
import { PropsWithChildren } from "react";
import { useLayout } from "../../../context/LayoutContext";
import styles from "./styleModule";

const ContentWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  const { getHeaderPadding } = useLayout();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  return (
    <div className={styles.container}>
      <div
        className={styles.contentWrapper}
        style={{ padding: getHeaderPadding() }}
      >
        <div
          className={styles.contentContainer}
          style={{ paddingTop: screens.md ? 48 : 28 }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default ContentWrapper;
